const commitments = [
  {
    icon: 'ri-medal-line',
    title: 'Techniciens certifiés',
    desc: "Une équipe d\'experts hautement qualifiés, formés en continu aux innovations du secteur, pour vous garantir des installations fiables et à la pointe de la technologie.",
    dark: false,
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Intervention rapide',
    desc: "Les interventions urgentes sont traitées en priorité, avec un engagement de réactivité afin de rétablir votre confort dans les plus brefs délais.",
    dark: true,
  },
  {
    icon: 'ri-leaf-line',
    title: 'Efficacité énergétique',
    desc: "Nous sélectionnons des systèmes de climatisation à haute performance énergétique, conçus pour optimiser votre confort tout en maîtrisant vos dépenses.",
    dark: false,
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantie 5 ans',
    desc: "Chaque compresseur bénéficie d\'une garantie 5 ans, vous assurant fiabilité, longévité et sérénité.",
    dark: true,
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Tarifs transparents',
    desc: "Devis gratuit, précis, sans surprise ni frais cachés. Engagement clair et fiable.",
    dark: false,
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'SAV disponible',
    desc: "Nos experts restent à votre disposition pour toute question, effectuer des réglages ou planifier une intervention.",
    dark: true,
  },
];

const CommitmentsSection = () => (
  <section id="engagements" className="w-full py-24 bg-white">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <span
          className="inline-block text-white text-xs font-bold px-5 py-2 rounded-full mb-4 tracking-widest uppercase"
          style={{ background: 'linear-gradient(90deg, #003580 0%, #4ab8d0 100%)' }}
        >
          Nos Engagements
        </span>
        <h2 className="text-4xl lg:text-5xl font-black leading-tight mb-4" style={{ color: '#002060' }}>
          Une exigence constante<br />à chaque étape
        </h2>
        <p className="text-[#4a6272] text-lg max-w-xl mx-auto">
          La qualité et la fiabilité sont au cœur de chacune de nos interventions, pour une satisfaction totale de nos clients.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {commitments.map(({ icon, title, desc, dark }) => (
          <div
            key={title}
            className="rounded-2xl p-8 border transition-all duration-300 hover:-translate-y-1 cursor-default"
            style={dark
              ? { background: 'linear-gradient(135deg, #003580 0%, #1a8abf 80%, #4ab8d0 100%)', border: 'none' }
              : { background: '#f0f8fc', borderColor: '#d0eaf7' }
            }
          >
            <div
              className="w-14 h-14 flex items-center justify-center rounded-xl mb-5"
              style={dark ? { background: 'rgba(255,255,255,0.2)' } : { background: 'linear-gradient(135deg, #003580 0%, #4ab8d0 100%)' }}
            >
              <i className={`${icon} text-white text-2xl`} />
            </div>
            <h3 className={`text-xl font-bold mb-3 ${dark ? 'text-white' : ''}`} style={dark ? {} : { color: '#002060' }}>
              {title}
            </h3>
            <p className={`text-sm leading-relaxed ${dark ? 'text-white/85' : 'text-[#4a6272]'}`}>{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CommitmentsSection;
